import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieContext';

const headingClass = 'mb-2.5 text-xs font-semibold uppercase tracking-[0.1em] text-gray-400 lg:mb-3';
const linkClass = 'text-gray-200 transition-colors hover:text-white';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { setShowBanner } = useCookieConsent();

  return (
    <footer className="bg-gray-800 text-sm leading-relaxed text-gray-200">
      <div className="mx-auto max-w-screen-xl px-5 pb-7 pt-9 lg:px-12 lg:pb-8 lg:pt-12">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-10">
          <div className="col-span-2 lg:col-span-1">
            <h2 className={headingClass}>Kontakt</h2>
            <address className="not-italic">
              <p>Flugsportverein Otto Lilienthal Bad Langensalza e.V.</p>
              <p className="mt-2">
                Thamsbrücker Landstraße 28
                <br />
                99947 Bad Langensalza
              </p>
              <p className="mt-2">
                <a href="tel:+4936038958503" className={linkClass}>
                  +49 3603 895 8503
                </a>
                <br />
                <a href="mailto:info@flugsportverein.eu" className={linkClass}>
                  info@flugsportverein.eu
                </a>
              </p>
            </address>
          </div>

          <div className="col-span-2 lg:col-span-1">
            <h2 className={headingClass}>Flugplatz</h2>
            <p>EDEB</p>
            <p>E 10° 37.30' / N 051° 07.75'</p>
            <p>Frequenz: 125,365 MHz</p>
            <Link to="/flugplatzinfo" className="mt-2 inline-block text-blue-300 transition-colors hover:text-white lg:mt-2.5">
              → Detaillierte Informationen für UL Piloten
            </Link>
          </div>

          <div>
            <h2 className={headingClass}>Links</h2>
            <ul className="flex flex-col gap-1.5">
              <li>
                <Link to="/impressum" className={linkClass}>
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className={linkClass}>
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <button type="button" onClick={() => setShowBanner(true)} className={`${linkClass} text-left`}>
                  Cookie-Einstellungen
                </button>
              </li>
              <li>
                <a href="https://www.instagram.com/flugsportverein_offiziell/" target="_blank" rel="noopener noreferrer" className={linkClass}>
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/flugsportverein.bad.langensalza" target="_blank" rel="noopener noreferrer" className={linkClass}>
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className={headingClass}>Downloads</h2>
            <a
              href="/downloads/Gebührenordnung Sonderlandeplatz Bad Langensalza EDEB.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className={linkClass}
            >
              Gebührenordnung EDEB (PDF)
            </a>
          </div>
        </div>

        <div className="mt-7 flex flex-col gap-1 border-t border-gray-700 pt-5 text-[13px] text-gray-400 lg:mt-9 lg:flex-row lg:justify-between lg:gap-6 lg:pt-6">
          {/* Jahr kann zwischen Vorrendern und Aufruf wechseln – Abweichung beim Hydrieren ist gewollt */}
          <p suppressHydrationWarning>
            &copy; {currentYear} Flugsportverein Otto Lilienthal Bad Langensalza e.V. Alle Rechte vorbehalten.
          </p>
          <p>Website entwickelt mit ❤️ von www.leanofy.de</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
